// Mount the Tenders package (#216): build its route from what it needs from this
// app — the generic host (modals, the signed-in user: host-base.ts) and the
// initialised i18n instance (it registers its `tenders` namespace there).
// App.tsx mounts the route from HERE, so the package cannot be mounted
// unregistered. configs/i18n is imported (and so initialised) before the
// registration runs, whatever order main.tsx imports things in. The HTTP client
// goes through core's registry (utils/axios/register-core.ts).
//
// Tenders has no link to another module's page, no permission list and no
// component to ask for, so the host is only `hostBase` and `i18n`. The route had
// no errorElement before and has none now.
import { createTendersModule } from '@vnetwork/datacentral-tenders'
import { hostBase } from '@/app/host-base'
import i18n from '@/configs/i18n'

export const TendersRoute = createTendersModule({ ...hostBase, i18n })
